/** Old System tab ids still open the matching place on the rebuilt page, and the reverse. */

export const LEGACY_TO_V2: Record<string, 'overview' | 'requests' | 'settings' | 'flags' | 'scripts' | 'repair'> = {
  general: 'settings',
  'data-repair': 'repair',
  normalization: 'scripts',
  'privacy-requests': 'requests',
  'feature-flags': 'flags',
  'release-steps': 'scripts',
};

export const V2_TO_LEGACY: Record<string, 'general' | 'data-repair' | 'normalization' | 'privacy-requests' | 'feature-flags' | 'release-steps'> = {
  overview: 'general',
  requests: 'privacy-requests',
  settings: 'general',
  flags: 'feature-flags',
  scripts: 'release-steps',
  repair: 'data-repair',
};

export const V2_TABS = ['overview', 'requests', 'settings', 'flags', 'scripts', 'repair'] as const;
export type SystemV2Tab = (typeof V2_TABS)[number];
